import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../../components/auth/useAuth'
import { addWorkOrder, getWorkOrder, getWorkOrders, duplicateWorkOrder, editWorkOrder, removeWorkOrder, getLastNumWorkOrder, getWorkOrdersCalendar } from '../../../actions/workOrdersActions'
import { getAnalisysTypes } from '../../../actions/analisysTypesActions'
import { getActiveBusinesses, getBusinesses } from '../../../actions/businessesActions'
import { getParameters } from '../../../actions/parametersActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import WorkOrderForm from '../../../components/forms/WorkOrderForm'
import AnalisysForm from '../../../components/forms/AnalisysForm'
import { addAnalisys, editAnalisys, getAnalisysByWorkOrder } from '../../../actions/analisysActions'
import { getActiveOperators } from '../../../actions/operatorsActions'
import Calendar from 'react-calendar'

export default function WorkOrders({ userType }) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { clientauth } = useAuth()

    const { workOrders, workOrder, resultWorkOrder, numWorkOrder, duplicatedWorkOrder, loading, total } = useSelector(state => state.workOrders)
    const { analisys, resultAnalisys } = useSelector(state => state.analises)
    const { analisysTypes } = useSelector(state => state.analisysTypes)
    const { businessesActives } = useSelector(state => state.businesses)
    const { parameters } = useSelector(state => state.parameters)
    const { operatorsActives } = useSelector(state => state.operators)

    const [modalShow, setModalShow] = useState(false)
    const [modalAnalisysShow, setModalAnalisysShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [formStateAnalisys, setFormStateAnalisys] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [sortField, setSortField] = useState('date')
    const [sortOrder, setSortOrder] = useState('desc')

    const [calendarShow, setCalendarShow] = useState(false)

    const { workOrdersCalendar } = useSelector(state => state.workOrders)
    const [currentDate, setCurrentDate] = useState(new Date())

    const [selectedDayOrders, setSelectedDayOrders] = useState([])
    const [selectedDayDate, setSelectedDayDate] = useState(null)
    const [dayModalShow, setDayModalShow] = useState(false)

    useEffect(() => {
        if (clientauth) {
            dispatch(getWorkOrders(page, limit, search, sortField, sortOrder))
            dispatch(getAnalisysTypes())
            dispatch(getActiveBusinesses())
            dispatch(getParameters())
            dispatch(getActiveOperators())
        }
    // eslint-disable-next-line
    }, [dispatch, clientauth, page, limit, search, sortField, sortOrder])

    const openModal = () => {
        setIsAddingOrEditing('adding')
        setFormState({
            numWorkOrder: numWorkOrder,
            date: new Date().toISOString().slice(0, 10)
        })
        dispatch(getLastNumWorkOrder(new Date().getFullYear()))
        setModalShow(true)
    }

    const selectWorkOrder = (workOrder) => {
        setIsAddingOrEditing('editing')

        setFormState({
            ...workOrder,
            numWorkOrder: workOrder.numWorkOrder,
            date: workOrder.date.split('T')[0],
            status: workOrder.status,
            business: workOrder.business?._id,
            businessBill: workOrder.businessBill?._id,
            address: workOrder.address || {
                address: '',
                province: '',
                location: ''
            },
            analisysType: {
                name: workOrder.analisysType.name,
                params: workOrder.analisysType.params.map(param => ({
                    parameter: param.parameter._id,
                    parameterName: param.parameter.name,
                    unitMeasure: param.unitMeasure,
                    minValue: param.minValue,
                    maxValue: param.maxValue
                }))
            }
        });

        setModalShow(true);
    }

    const handleDuplicateWorkOrder = (workOrder) => {
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'warning',
            html: t('admin.workOrders.areyousureduplicate')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(duplicateWorkOrder(workOrder._id))
            }
        })
    }

    const selectAnalisys = (workOrder) => {
        dispatch(getAnalisysByWorkOrder(workOrder._id))
        dispatch(getWorkOrder(workOrder._id))

        const formattedDate = new Intl.DateTimeFormat('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
            .format(new Date()).replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+)/, '$3-$2-$1T$4:$5');

        setFormStateAnalisys({
            workOrder: workOrder._id,
            name: workOrder.name,
            date: formattedDate
        })

        setModalAnalisysShow(true)
    }

    useEffect(() => {
        if (analisys) {
            setIsAddingOrEditing('editing')
            const formattedDate = new Intl.DateTimeFormat('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
                .format(new Date(analisys.date)).replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+)/, '$3-$2-$1T$4:$5');

            setFormStateAnalisys({
                ...analisys,
                date: formattedDate
            })
        } else {
            setIsAddingOrEditing('adding')
            if (analisys === false) {
                setFormStateAnalisys({
                    ...formStateAnalisys,
                    user: clientauth?.id,
                    measures: []
                })
            }
        }
        // eslint-disable-next-line
    }, [analisys])

    useEffect(() => {
        if (numWorkOrder) {
            setFormState({ ...formState, numWorkOrder: numWorkOrder })
        }
    }, [numWorkOrder])

    const handleSort = (column, sortDirection) => {
        setSortField(column.id || 'date')
        setSortOrder(sortDirection)
        setPage(1)
    }

    const handleInputChange = ({ target }) => {
        if (target.name === 'date' && target.value.split('-')[0] !== formState?.date?.split('-')[0]) {
            dispatch(getLastNumWorkOrder(new Date(target.value).getFullYear()))
        }

        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleInputChangeAnalisys = ({ target }) => {
        setFormStateAnalisys({
            ...formStateAnalisys,
            [target.name]: target.value
        })
    }

    const handleSelectChange = ({ target }) => {
        if (target.name === "analisysType") {
            const selectedType = analisysTypes.find(type => type._id === target.value);
            if (selectedType) {
                setFormState(prevState => ({
                    ...prevState,
                    analisysType: {
                        name: selectedType.name,
                        params: selectedType.params.map(param => ({
                            parameter: param.parameter._id,
                            parameterName: param.parameter.name,
                            unitMeasure: param.unitMeasure || "",
                            minValue: param.minValue || 0,
                            maxValue: param.maxValue || 0
                        }))
                    }
                }))
            }
        } else {
            setFormState(prevState => ({
                ...prevState,
                [target.name]: target.value
            }))
        }
    }

    const handleSubmit = async (e, forcedStatus = null) => {
        e.preventDefault()
        setIsRegistering(true)

        const statusToUse = forcedStatus ?? formState.status

        const newFormState = {
            ...formState,
            status: statusToUse,
            analisysType: {
                name: formState.analisysType?.name || "",
                params: formState.analisysType?.params || []
            }
        }

        if (isAddingOrEditing === 'editing') {
            await dispatch(editWorkOrder(newFormState, newFormState._id))
        } else {
            dispatch(addWorkOrder(newFormState))
        }

        setIsRegistering(false)
    }


    const handleSubmitAnalisys = async (e) => {
        e.preventDefault()
        setIsRegistering(true)

        if (isAddingOrEditing === 'editing') {
            dispatch(editAnalisys(formStateAnalisys, formStateAnalisys._id))
        } else {
            dispatch(addAnalisys(formStateAnalisys))
        }
        setIsRegistering(false)
    }

    const handleDeleteWorkOrders = async (e, workOrderId) => {
        e.preventDefault()
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'warning',
            html: t('admin.workOrders.areyousureremove')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeWorkOrder(workOrderId))
                setModalShow(false)
            }
        })
    }

    const loadWorkOrdersByMonth = (date) => {
        const year = date.getFullYear()
        const month = date.getMonth()

        const dateFrom = new Date(year, month, 1)
        const dateTo = new Date(year, month + 1, 0)

        dispatch(getWorkOrdersCalendar(dateFrom, dateTo))
    }

    const workOrdersByDay = React.useMemo(() => {
        if (!Array.isArray(workOrdersCalendar)) return {}

        const map = {}

        workOrdersCalendar.forEach(wo => {
            const date = new Date(wo.date)
            const key = date.toISOString().split('T')[0]

            if (!map[key]) map[key] = []
            map[key].push(wo)
        })

        return map
    }, [workOrdersCalendar])

    useEffect(() => {
        if (calendarShow) {
            loadWorkOrdersByMonth(currentDate)
        }
    }, [calendarShow, isRegistering])

    useEffect(() => {
        if (resultWorkOrder) {
            let resultWorkOrderTemp = resultWorkOrder
            dispatch({ type: 'WORKORDER_RESET_RESULT' })
            switch (resultWorkOrderTemp) {
                case 'addsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.workOrders.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                case 'deletesuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.workOrders.deletesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                case 'editsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.workOrders.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setModalAnalisysShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                case 'duplicatesuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.workOrders.duplicatesuccess')
                    }).then(() => {
                        if (duplicatedWorkOrder) {
                            selectWorkOrder(duplicatedWorkOrder)
                            setModalShow(true)
                        }
                    })
                    break
                case 'duplicated':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'warning',
                        text: t('admin.workOrders.duplicated')
                    })
                    break
                default:
                    break
            }
        }
        // eslint-disable-next-line
    }, [resultWorkOrder])

    useEffect(() => {
        if (resultAnalisys) {
            let resultAnalisysTemp = resultAnalisys
            dispatch({ type: 'ANALISYS_RESET_RESULT' })
            switch (resultAnalisysTemp) {
                case 'addsuccessanalisys':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.analises.addsuccessanalisys')
                    }).then(() => {
                        setModalShow(false)
                        setModalAnalisysShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break
                case 'editsuccessanalisys':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.analises.editsuccessanalisys')
                    }).then(() => {
                        setModalShow(false)
                        setModalAnalisysShow(false)
                        setIsAddingOrEditing(false)
                        dispatch(getWorkOrders(page, limit, search, sortField, sortOrder))
                    })
                    break
                default:
                    break
            }
        }
        // eslint-disable-next-line
    }, [resultAnalisys])

    const columnsWorkOrders = [
        {
            id: 'date',
            name: t('admin.workOrders.date'),
            grow: 1,
            cell: workOrder =>
                <div className='cursor' onClick={() => userType === 'Admin' ? selectWorkOrder(workOrder) : selectAnalisys(workOrder)}>
                    {new Date(workOrder.date).toLocaleDateString()}
                </div>,
            selector: (workOrder) => `${workOrder.date}`,
            sortable: true,
        }, {
            id: 'numWorkOrder',
            name: t('admin.workOrders.numWorkOrder'),
            grow: 0.5,
            cell: workOrder =>
                <div className='cursor' onClick={() => userType === 'Admin' ? selectWorkOrder(workOrder) : selectAnalisys(workOrder)}>
                    {workOrder.numWorkOrder}
                </div>,
            selector: (workOrder) => `${workOrder.numWorkOrder}`,
            sortable: true,
        }, {
            id: 'analisysType',
            name: t('admin.workOrders.analisysType'),
            grow: 1,
            cell: workOrder =>
                <div className='cursor' onClick={() => userType === 'Admin' ? selectWorkOrder(workOrder) : selectAnalisys(workOrder)}>
                    {workOrder.analisysType?.name || ''}
                </div>,
            selector: (workOrder) => `${workOrder.analisysType?.name || ''}`,
            sortable: true,
        }, {
            id: 'business',
            name: t('admin.workOrders.business'),
            grow: 3,
            cell: workOrder =>
                <div className='cursor text-start' onClick={() => userType === 'Admin' ? selectWorkOrder(workOrder) : selectAnalisys(workOrder)}>
                    {workOrder.business?.name}
                </div>,
            selector: (workOrder) => `${workOrder.business?.name}`,
            sortable: true,
        }, {
            name: t('admin.analises.completed'),
            center: "true",
            grow: 1,
            cell: workOrder =>
                <div className='cursor text-center' onClick={() => userType === 'Admin' ? selectWorkOrder(workOrder) : selectAnalisys(workOrder)}>
                    {workOrder?.completedSamples + '/' + workOrder?.analisysQuantity}
                </div>
        }, {
            name: t('admin.analises.outOfRange'),
            center: "true",
            grow: 1,
            cell: workOrder =>
                <div className='cursor text-center' onClick={() => userType === 'Admin' ? selectWorkOrder(workOrder) : selectAnalisys(workOrder)}>
                    {workOrder?.outOfRangeParams}
                </div>
        }, {
            id: 'status',
            name: t('global.status'),
            grow: 0.5,
            cell: workOrder =>
                <div className='cursor' onClick={() => userType === 'Admin' ? selectWorkOrder(workOrder) : selectAnalisys(workOrder)}>
                    {t('admin.workOrders.status_' + workOrder?.status) || ''}
                </div>,
            selector: (workOrder) => `${workOrder?.status || ''}`,
            sortable: true,
        }, {
            name: t('global.actions'),
            center: "true",
            grow: 1.5,
            cell: workOrder =>
                <>
                    {userType === 'Admin' &&
                        <>
                            <div className='cursor mx-2' onClick={() => selectWorkOrder(workOrder)}>
                                <i className='fas fa-pencil'></i>
                            </div>
                            <div className='cursor mx-2' onClick={() => handleDuplicateWorkOrder(workOrder)}>
                                <i className='fas fa-copy'></i>
                            </div>
                            <div className='cursor mx-2' onClick={(e) => handleDeleteWorkOrders(e, workOrder._id)}>
                                <i className='fas fa-trash'></i>
                            </div>
                        </>
                    }
                    {workOrder?.status !== 'new' &&
                        <div className='cursor mx-2' onClick={() => selectAnalisys(workOrder)}>
                            <i className='fas fa-microscope'></i>
                        </div>
                    }
                </>,
            sortable: false,
        }
    ]

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col className='text-center'>
                    <h1>{t('admin.workOrders.workOrders')}</h1>
                </Col>
            </Row>
            <Row>
                {userType === 'Admin' &&
                    <Col xs={12} className='d-flex justify-content-end'>
                        <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                            {t('admin.workOrders.createworkOrder')}
                        </Button>
                    </Col>
                }
            </Row>
            {loading && !workOrders ?
                <Loader />
                :
                <Container>
                    <Row className='justify-content-end'>
                        <Col xs={12} md={8} className='d-flex align-items-center'>
                            <Button onClick={() => setCalendarShow(!calendarShow)}><i class="fa-solid fa-calendar-days"></i></Button>
                        </Col>
                        <Col xs={12} md={4} className='d-flex align-items-center'>
                            <input
                                type="text"
                                className="form-control me-2"
                                placeholder={t("datatables.buscar")}
                                value={searchAux || ""}
                                onChange={e => {
                                    setSearchAux(e.target.value);
                                    setPage(1);
                                }}
                                onKeyDown={(e) => { if (e.key === 'Enter') { setSearch(searchAux); setPage(1); } }}
                            />
                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>

                            {workOrders?.length > 0 ?
                                    <CustomDataTable
                                        columns={columnsWorkOrders}
                                        data={workOrders.filter(workOrder => {
                                            if (userType === 'Laboratory') {
                                                return workOrder.status === 'inProgress' || workOrder.status === 'finished';
                                            }
                                            return true;
                                        })}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={total}
                                        paginationPerPage={limit}
                                        progressPending={loading}
                                        sortServer
                                        onSort={handleSort}
                                        defaultSortField={sortField}
                                        defaultSortAsc={sortOrder !== 'desc'}
                                        exportable={false}
                                        printable={false}
                                        onChangeRowsPerPage={(newLimit) => {
                                            setLimit(newLimit)
                                            setPage(1)
                                        }}
                                        onChangePage={(newPage) => {
                                            setPage(newPage)
                                        }}
                                    />
                                    :
                                    <h4 className='mt-4'>{t('admin.workOrders.thereisnotworkOrders')}</h4>
                            }
                        </Col>
                    </Row>
                </Container>
            }
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.workOrders.workOrders')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <WorkOrderForm
                        state={formState}
                        analisysTypes={analisysTypes}
                        operators={operatorsActives}
                        businessesActive={businessesActives}
                        parameters={parameters}
                        handleInputChange={handleInputChange}
                        handleSelectChange={handleSelectChange}
                        handleDeleteWorkOrders={handleDeleteWorkOrders}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        userType={userType}
                    />
                </Modal.Body>
            </Modal>
            <Modal
                show={modalAnalisysShow}
                onHide={() => { setModalAnalisysShow(false); }}
                aria-labelledby="contained-modal-title-vcenter"
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.workOrders.workOrders')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AnalisysForm
                        state={formStateAnalisys}
                        workOrder={workOrder}
                        handleInputChange={handleInputChangeAnalisys}
                        submit={handleSubmitAnalisys}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        userType={userType}
                    />
                </Modal.Body>
            </Modal>
            <Modal
                show={calendarShow}
                onHide={() => { setCalendarShow(false); }}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h2>{t('admin.workOrders.calendar')}</h2>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Calendar
                        className="custom-calendar p-2 shadow-sm rounded w-100"
                        value={currentDate}
                        onActiveStartDateChange={({ activeStartDate }) => {
                            setCurrentDate(activeStartDate)
                            loadWorkOrdersByMonth(activeStartDate)
                        }}
                        tileContent={({ date, view }) => {
                            if (view !== 'month') return null

                            const key = date.getFullYear() + '-' +
                                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                                String(date.getDate()).padStart(2, '0')
                            const orders = workOrdersByDay[key]

                            if (!orders) return null

                            return (
                                <div style={{
                                    marginTop: 5,
                                    maxHeight: 60,
                                    overflow: 'hidden'
                                }}>
                                    {orders.slice(0, 2).map(o => (
                                        <div
                                            key={o._id}
                                            title={`${o.numWorkOrder} - ${o.business?.name}`}
                                            style={{
                                                fontSize: '10px',
                                                background: '#198754',
                                                color: 'white',
                                                borderRadius: 4,
                                                padding: '2px 4px',
                                                marginBottom: 2,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                maxWidth: '100%'
                                            }}
                                        >
                                            {o.analisysType?.name || `#${o.numWorkOrder}`}
                                        </div>
                                    ))}

                                    {orders.length > 2 && (
                                        <div style={{ fontSize: '10px' }}>
                                            +{orders.length - 2} {t("admin.workOrders.more")}
                                        </div>
                                    )}
                                </div>
                            )
                        }}
                        onClickDay={(date) => {
                            const key = date.getFullYear() + '-' +
                                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                                String(date.getDate()).padStart(2, '0')

                            const orders = workOrdersByDay[key] || []

                            setSelectedDayOrders(orders)
                            setSelectedDayDate(date)
                            setDayModalShow(true)
                        }}
                    />
                </Modal.Body>
            </Modal>
            <Modal
                show={dayModalShow}
                onHide={() => setDayModalShow(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("admin.workOrders.workOrdersDay") + " " + selectedDayDate?.toLocaleDateString()}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {selectedDayOrders.length === 0 ? (
                        <p>{t("admin.workOrders.noOrders")}</p>
                    ) : (
                        selectedDayOrders.map(o => (
                            <div
                                key={o._id}
                                className="p-2 mb-2 border rounded cursor"
                                onClick={() => {
                                    setDayModalShow(false)
                                    userType === 'Admin'
                                        ? selectWorkOrder(o)
                                        : selectAnalisys(o)
                                }}
                            >
                                <strong>#{o.numWorkOrder}</strong><br />
                                {o.business?.name}<br />
                                <small>{o.analisysType?.name}</small>
                            </div>
                        ))
                    )}
                </Modal.Body>
            </Modal>
        </Container>
    )
}